<i18n lang="yaml">
  pt:
    open-tutorial: "Abrir tutorial"
</i18n>

<template>
  <article class="tutorial">
    <div
      data-grid
      class="tutorial__wrapper grid--between grid--va-center"
    >
      <div class="tutorial__textblock">
        <h2 class="tutorial__title m-0">
          {{ tutorial.title }}
        </h2>

        <p class="tutorial__description">
          {{ tutorial.description }}
        </p>
      </div>

      <a
        data-grid="nowrap"
        :href="tutorial.anchor"
        class="tutorial__anchor grid--va-center p-2 growing-effect"
      >
        <span
          data-grid
          class="tutorial__playicon grid--va-center grid--center"
        >
          <PlayIcon class="w-50 h-50" />
        </span>

        {{ $t('open-tutorial') }}
      </a>
    </div>
  </article>
</template>

<script>
import { defineComponent } from 'vue'

import PlayIcon from '../../../icons/PlayIcon'

export default defineComponent({
  name: 'TutorialItem',

  components: {
    PlayIcon
  },

  props: {
    tutorial: {
      type: Object,
      required: true,
      validator (tutorial) {
        return !!tutorial.anchor
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .tutorial {
    padding: 26px;
    max-width: 620px;
    border-radius: 8px;
    background-color: rgb(var(--white));

    & + :deep(.tutorial) {
      margin: 30px 0 0;
    }

    &__textblock {
      max-width: 50%;
    }

    &__title {
      color: rgb(var(--gray8));
      font: 600 1.9rem "Archivo", sans-serif;
    }

    &__description {
      margin: 23px 0 0;

      color: rgb(var(--gray1));
      font: 400 1.4rem "Nunito", sans-serif;
    }

    &__anchor {
      width: 193px;
      height: 54px;

      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(var(--black1), .1);

      color: rgb(var(--gray1));
      font: 700 1.5rem "Nunito", sans-serif;
    }

    &__playicon {
      color: rgb(var(--white));

      width: 20px;
      height: 20px;

      border-radius: 50%;
      margin-inline: 0 18px;
      background-color: rgb(var(--orange2));
    }
  }
</style>
